require('./cancelBizum.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @ commons
const { formatText } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ constants
const { WIZARD_VERTICAL_VIEW_MODE } = require('constants/index');
const { CANCEL_BIZUM } = require('constants/contactCenter/operationTypes');
const errorCodes = require('constants/contactCenter/cancelBizumErrorCodes');

// @ components
const CancelBizumStep1 = require('components/contactCenter/bizum/cancelBizum/cancelBizumStep1/cancelBizumStep1');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');

class CancelBizum extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleGoBack = this.handleGoBack.bind(this);
        this.handleToggleCancelModal = this.handleToggleCancelModal.bind(this);
        this.state = {
            showModal: false
        };
    }

    componentDidMount() {
        this.props.queryContract();
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    buildSuccessMessage() {
        const title = formatText('cancelBizumFeedbackSuccess-title');
        const textLink = formatText('cancelBizum-back');
        const goBackHandler = this.handleGoBack;
        const extraContent = (
            <div className="cancel-bizum__custom-block-info">
                <BlockInfo>
                    {formatText('cancelBizumFeedbackSuccess-description')}
                </BlockInfo>
            </div>
        );

        return (
            <div className="cancel-bizum__feedback">
                <CustomMessageBox
                    icon="icon-success"
                    title={title}
                    extraContent={extraContent}
                    textLink={textLink}
                    goBackHandler={goBackHandler}
                />
            </div>
        );
    }

    buildErrorContractNotFound() {
        const title = formatText('cancelBizumFeedbackError-titleContractNotFound');
        const subtitle = formatText('cancelBizumFeedbackError-descriptionContractNotFound');
        const textLink = formatText('cancelBizum-back');
        const goBackHandler = this.handleGoBack;

        return (
            <div className="cancel-bizum__feedback">
                <CustomMessageBox
                    icon="icon-warning"
                    title={title}
                    subtitle={subtitle}
                    textLink={textLink}
                    goBackHandler={goBackHandler}
                />
            </div>
        );
    }

    buildErrorMessage() {
        const title = formatText('cancelBizumFeedbackError-title');
        const textLink = formatText('cancelBizum-back');
        const goBackHandler = this.handleGoBack;
        const extraContent = (
            <div className="cancel-bizum__custom-block-info">
                <BlockInfo>
                    {formatText('cancelBizumFeedbackError-description')}
                </BlockInfo>
            </div>
        );

        return (
            <div className="cancel-bizum__feedback">
                <CustomMessageBox
                    icon="icon-warning"
                    title={title}
                    extraContent={extraContent}
                    textLink={textLink}
                    goBackHandler={goBackHandler}
                />
            </div>
        );
    }

    handleFinish() {
        this.props.handleFinish();
    }

    handleCancel() {
        this.props.history.push('/myprofile/transfers');
    }

    handleGoBack(){
        this.props.history.push('/myprofile/transfers');
    }

    handleToggleCancelModal() {
        this.setState({showModal: !this.state.showModal});
    }

    buildPreleaveCancelModal() {
        return (
            <PreleaveCancelModal
                isOpen={this.state.showModal}
                onCancel={this.handleCancel}
                onCloseModal={this.handleToggleCancelModal}
                onStayHere={this.handleToggleCancelModal}
            />
        );
    }

    buildWizard() {
        const { immCancelBizum, validateStep, setVisibleStep } = this.props;
        const immSteps = immCancelBizum.get('steps');
        const isSaving = immCancelBizum.get('isSaving');
        const invalidSecurityData = immCancelBizum.get('invalidSecurityDataError');

        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel: () => {},
            finish: this.handleFinish,
            cancel: this.handleToggleCancelModal
        };

        const operationParams = {};

        return (
            <Wizard
                viewMode={WIZARD_VERTICAL_VIEW_MODE}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immCancelBizum.get('visibleStep')}
                wizardClass="cancel-bizum__wizard"
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    nextButtonLabel="common-confirm"
                >
                    <CancelBizumStep1 />
                </WizardStep>
                <WizardStep
                    position="last"
                    omitPreviousButton={true}
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={isSaving}
                    immFinalButton="cancelBizumVerifyOtpStep-finalButtonLabel"
                >
                    <VerifyOtpStep
                        operationType={CANCEL_BIZUM}
                        operationParams={operationParams}
                        invalidSecurityData={invalidSecurityData}
                    />
                </WizardStep>
            </Wizard>
        )
    }

    buildBodyContent() {
        const { immCancelBizum } = this.props;
        const isFetching = immCancelBizum.get('isFetching');
        const submitSuccessful = immCancelBizum.get('submitSuccessful');
        const submitError = immCancelBizum.get('submitError');
        const fetchError = immCancelBizum.get('fetchError');
        const fetchErrorCode = immCancelBizum.get('fetchErrorCode');
        const errorMessage = this.buildErrorMessage();
        const errorContractNotFound = this.buildErrorContractNotFound();
        const successMessage = this.buildSuccessMessage();
        const wizard = this.buildWizard();
        const preleaveCancelModal = this.buildPreleaveCancelModal();
        let content;

        if (isFetching) {
            content = <LoadingSection />;

        } else if (submitSuccessful) {
            content = successMessage;

        } else if (submitError) {
            content = errorMessage;

        } else if (fetchError && fetchErrorCode === errorCodes.CONTRACT_NOT_FOUND) {
            content = errorContractNotFound;

        } else if (fetchError) {
            content = errorMessage;

        } else {
            content = (
                <div>
                    {wizard}
                    {preleaveCancelModal}
                </div>
            );
        }

        return (
            <div className="row no-outside-gutter">
                <div className="col-xs-12">
                    <div className="cancel-bizum__body-content">
                        {content}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-transfers'),
                url: '/myprofile/transfers'
            },
            {
                text: formatText('cancelBizum-title'),
                url: ''
            }
        ];

        const bodyContent = this.buildBodyContent();

        return (
            <section className="cancel-bizum">
                <OKCover size="medium" section="transfers" extraClass="cancel-bizum">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        finalTitle={formatText('cancelBizum-title')}
                        isSubtitleLeftCapital={false}
                        overlap={true}
                    />
                </OKCover>
                <div className="cancel-bizum__body grid-view--content-position-negative">
                    {bodyContent}
                </div>
            </section>
        );
    }
}

CancelBizum.propTypes = {
    history: PropTypes.object.isRequired,
    immCancelBizum: PropTypes.object.isRequired,
    queryContract: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
};

module.exports = withRouter(CancelBizum);
